import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "shopping-bag",
  "use": "shopping-bag-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 22\" id=\"shopping-bag\"><g stroke=\"#002C5B\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M4 1L1 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5l-3-4H4zM1 5h18M14 9a4 4 0 1 1-8 0\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol